var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	45652: () => (loadSingletonVersionCheckFallback("default", "@angular/core", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0_node_modules_angular_core_fes-5f8e1c").then(() => (() => (__webpack_require__(/*! @angular/core */ 69789))))))),
	62182: () => (loadSingletonVersionCheckFallback("default", "@angular/animations", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_animations_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__n-705bdd1").then(() => (() => (__webpack_require__(/*! @angular/animations */ 7799))))))),
	73558: () => (loadSingletonVersionCheckFallback("default", "@angular/common", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_-e8892e1").then(() => (() => (__webpack_require__(/*! @angular/common */ 46033))))))),
	35581: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/layout", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-35142b1").then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 15114))))))),
	38928: () => (loadSingletonVersionCheckFallback("default", "rxjs/operators", [4,7,8,1], () => (__webpack_require__.e("node_modules_pnpm_rxjs_7_8_1_node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 8371))))))),
	57261: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/platform", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-513f7e1").then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 35349))))))),
	64729: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/coercion", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-42e5151").then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 65812))))))),
	69473: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/keycodes", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-437b64").then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 26597))))))),
	84932: () => (loadSingletonVersionCheckFallback("default", "rxjs", [4,7,8,1], () => (__webpack_require__.e("node_modules_pnpm_rxjs_7_8_1_node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 64165))))))),
	90065: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/observers", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-249bf51").then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 45705))))))),
	5853: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/a11y", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-51a67b1").then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 67284))))))),
	67233: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/scrolling", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-0af4f61").then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 5073))))))),
	78969: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/bidi", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-fbbdc71").then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 81594))))))),
	13653: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/portal", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-d452871").then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 55198))))))),
	19869: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/collections", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-e044de1").then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 52319))))))),
	2846: () => (loadSingletonVersionCheckFallback("default", "@angular/core/primitives/signals", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0_node_modules_angular_core_fes-dfb187").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 55940))))))),
	77712: () => (loadSingletonVersionCheckFallback("default", "@angular/core/primitives/event-dispatch", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0_node_modules_angular_core_fes-2510de").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/event-dispatch */ 24814))))))),
	18493: () => (loadSingletonVersionCheckFallback("default", "@angular/platform-browser", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_platform-browser_18_1_2__angular_animations_18_1_2__angular_core_18-5786650").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 31003))))))),
	51618: () => (loadSingletonVersionCheckFallback("default", "@angular/animations/browser", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_animations_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__n-bfe7a51").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 21522))))))),
	35072: () => (loadSingletonVersionCheckFallback("default", "@angular/common/http", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_-1967501").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 47034))))))),
	3129: () => (loadSingletonVersionCheckFallback("default", "@awesome-cordova-plugins/core", [4,6,8,0], () => (__webpack_require__.e("node_modules_pnpm_awesome-cordova-plugins_core_6_8_0_rxjs_7_8_1_node_modules_awesome-cordova--391b38").then(() => (() => (__webpack_require__(/*! @awesome-cordova-plugins/core */ 79022))))))),
	44962: () => (loadSingletonVersionCheckFallback("default", "tslib", [4,2,5,0], () => (__webpack_require__.e("node_modules_pnpm_tslib_2_5_0_node_modules_tslib_tslib_es6_js").then(() => (() => (__webpack_require__(/*! tslib */ 15279))))))),
	24003: () => (loadSingletonVersionCheckFallback("default", "@capacitor/core", [4,8,2,0], () => (__webpack_require__.e("node_modules_pnpm_capacitor_core_8_2_0_node_modules_capacitor_core_dist_index_js").then(() => (() => (__webpack_require__(/*! @capacitor/core */ 73665))))))),
	16786: () => (loadSingletonVersionCheckFallback("default", "@angular/forms", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_forms_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1-f1f5b01").then(() => (() => (__webpack_require__(/*! @angular/forms */ 21755))))))),
	95607: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/overlay", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-3c102c1").then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 38056))))))),
	1508: () => (loadSingletonVersionCheckFallback("default", "async", [4,3,2,5], () => (__webpack_require__.e("node_modules_pnpm_async_3_2_5_node_modules_async_dist_async_mjs").then(() => (() => (__webpack_require__(/*! async */ 36961))))))),
	2779: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/drag-drop", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-2f30271").then(() => (() => (__webpack_require__(/*! @angular/cdk/drag-drop */ 42832))))))),
	2935: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/table", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-93c8c01").then(() => (() => (__webpack_require__(/*! @angular/cdk/table */ 71332))))))),
	3169: () => (loadSingletonVersionCheckFallback("default", "@capgo/capacitor-file-picker", [4,8,1,3], () => (__webpack_require__.e("node_modules_pnpm_capgo_capacitor-file-picker_8_1_3__capacitor_core_8_2_0_node_modules_capgo_-9b64ae1").then(() => (() => (__webpack_require__(/*! @capgo/capacitor-file-picker */ 63964))))))),
	3295: () => (loadSingletonVersionCheckFallback("default", "@capacitor/clipboard", [4,8,0,1], () => (__webpack_require__.e("node_modules_pnpm_capacitor_clipboard_8_0_1__capacitor_core_8_2_0_node_modules_capacitor_clip-70a4311").then(() => (() => (__webpack_require__(/*! @capacitor/clipboard */ 70803))))))),
	3539: () => (loadSingletonVersionCheckFallback("default", "@ionic-native/file-chooser/ngx", [4,5,36,0], () => (__webpack_require__.e("node_modules_pnpm_ionic-native_file-chooser_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs-ff699b0").then(() => (() => (__webpack_require__(/*! @ionic-native/file-chooser/ngx */ 33054))))))),
	5524: () => (loadSingletonVersionCheckFallback("default", "@capacitor/screen-orientation", [4,8,0,1], () => (__webpack_require__.e("node_modules_pnpm_capacitor_screen-orientation_8_0_1__capacitor_core_8_2_0_node_modules_capac-979e2a1").then(() => (() => (__webpack_require__(/*! @capacitor/screen-orientation */ 42227))))))),
	5738: () => (loadSingletonVersionCheckFallback("default", "capacitor-plugin-security-check", [4,0,0,18], () => (__webpack_require__.e("node_modules_pnpm_capacitor-plugin-security-check_0_0_18__capacitor_core_8_2_0_node_modules_c-fb3cb11").then(() => (() => (__webpack_require__(/*! capacitor-plugin-security-check */ 64917))))))),
	5938: () => (loadSingletonVersionCheckFallback("default", "jsbarcode", [4,3,11,6], () => (__webpack_require__.e("node_modules_pnpm_jsbarcode_3_11_6_node_modules_jsbarcode_bin_JsBarcode_js").then(() => (() => (__webpack_require__(/*! jsbarcode */ 42852))))))),
	10734: () => (loadSingletonVersionCheckFallback("default", "file-saver", [4,2,0,5], () => (__webpack_require__.e("node_modules_pnpm_file-saver_2_0_5_node_modules_file-saver_dist_FileSaver_min_js").then(() => (() => (__webpack_require__(/*! file-saver */ 85065))))))),
	14183: () => (loadSingletonVersionCheckFallback("default", "swiper/element/bundle", [4,11,1,8], () => (__webpack_require__.e("node_modules_pnpm_swiper_11_1_8_node_modules_swiper_swiper-element-bundle_mjs").then(() => (() => (__webpack_require__(/*! swiper/element/bundle */ 26557))))))),
	14393: () => (loadSingletonVersionCheckFallback("default", "@meddv/ngx-pinch-zoom", [4,18,0,1], () => (__webpack_require__.e("node_modules_pnpm_meddv_ngx-pinch-zoom_18_0_1__angular_common_18_1_2__angular_core_18_1_2_rxj-0ddfaf0").then(() => (() => (__webpack_require__(/*! @meddv/ngx-pinch-zoom */ 43793))))))),
	20293: () => (loadSingletonVersionCheckFallback("default", "@capacitor/browser", [4,8,0,2], () => (__webpack_require__.e("node_modules_pnpm_capacitor_browser_8_0_2__capacitor_core_8_2_0_node_modules_capacitor_browse-b2ba0f1").then(() => (() => (__webpack_require__(/*! @capacitor/browser */ 54068))))))),
	21893: () => (loadSingletonVersionCheckFallback("default", "ngx-image-compress", [4,18,1,5], () => (__webpack_require__.e("node_modules_pnpm_ngx-image-compress_18_1_5__angular_common_18_1_2__angular_core_18_1_2_rxjs_-fc55b71").then(() => (() => (__webpack_require__(/*! ngx-image-compress */ 65439))))))),
	24210: () => (loadSingletonVersionCheckFallback("default", "@capacitor/camera", [4,8,0,2], () => (__webpack_require__.e("node_modules_pnpm_capacitor_camera_8_0_2__capacitor_core_8_2_0_node_modules_capacitor_camera_-1f1b4b1").then(() => (() => (__webpack_require__(/*! @capacitor/camera */ 338))))))),
	28145: () => (loadSingletonVersionCheckFallback("default", "@ionic/angular", [4,8,2,6], () => (__webpack_require__.e("node_modules_pnpm_ionic_angular_8_2_6__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0___angula-42f6001").then(() => (() => (__webpack_require__(/*! @ionic/angular */ 15809))))))),
	33562: () => (loadSingletonVersionCheckFallback("default", "suneditor", [1,2,47,0], () => (__webpack_require__.e("node_modules_pnpm_suneditor_2_47_8_node_modules_suneditor_src_suneditor_js").then(() => (() => (__webpack_require__(/*! suneditor */ 71269))))))),
	39579: () => (loadSingletonVersionCheckFallback("default", "@capacitor/preferences", [4,8,0,1], () => (__webpack_require__.e("node_modules_pnpm_capacitor_preferences_8_0_1__capacitor_core_8_2_0_node_modules_capacitor_pr-3bf03d0").then(() => (() => (__webpack_require__(/*! @capacitor/preferences */ 23763))))))),
	39795: () => (loadSingletonVersionCheckFallback("default", "@awesome-cordova-plugins/http/ngx", [4,6,8,0], () => (__webpack_require__.e("node_modules_pnpm_awesome-cordova-plugins_http_6_8_0__awesome-cordova-plugins_core_6_8_0_rxjs-8debf21").then(() => (() => (__webpack_require__(/*! @awesome-cordova-plugins/http/ngx */ 49313))))))),
	42069: () => (loadSingletonVersionCheckFallback("default", "@ionic-native/android-permissions/ngx", [4,5,36,0], () => (__webpack_require__.e("node_modules_pnpm_ionic-native_android-permissions_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_-dbaa2e0").then(() => (() => (__webpack_require__(/*! @ionic-native/android-permissions/ngx */ 9868))))))),
	43378: () => (loadSingletonVersionCheckFallback("default", "@ngx-translate/core", [4,15,0,0], () => (__webpack_require__.e("node_modules_pnpm_ngx-translate_core_15_0_0__angular_common_18_1_2__angular_core_18_1_2_rxjs_-a73e531").then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 97821))))))),
	43509: () => (loadSingletonVersionCheckFallback("default", "crypto-js", [4,4,2,0], () => (__webpack_require__.e("node_modules_pnpm_crypto-js_4_2_0_node_modules_crypto-js_index_js").then(() => (() => (__webpack_require__(/*! crypto-js */ 91186))))))),
	44336: () => (loadSingletonVersionCheckFallback("default", "ngxtension/create-notifier", [4,4,3,2], () => (__webpack_require__.e("node_modules_pnpm_ngxtension_4_3_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zon-826c9a1").then(() => (() => (__webpack_require__(/*! ngxtension/create-notifier */ 95651))))))),
	44718: () => (loadSingletonVersionCheckFallback("default", "@awesome-cordova-plugins/diagnostic/ngx", [4,6,8,0], () => (__webpack_require__.e("node_modules_pnpm_awesome-cordova-plugins_diagnostic_6_8_0__awesome-cordova-plugins_core_6_8_-4b43010").then(() => (() => (__webpack_require__(/*! @awesome-cordova-plugins/diagnostic/ngx */ 8837))))))),
	47514: () => (loadSingletonVersionCheckFallback("default", "capacitor-google-play-services-checker", [4,0,1,1], () => (__webpack_require__.e("node_modules_pnpm_capacitor-google-play-services-checker_0_1_1__capacitor_core_8_2_0_node_mod-5a81871").then(() => (() => (__webpack_require__(/*! capacitor-google-play-services-checker */ 32817))))))),
	50655: () => (loadSingletonVersionCheckFallback("default", "@ionic-native/file/ngx", [4,5,36,0], () => (__webpack_require__.e("node_modules_pnpm_ionic-native_file_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs_7_8_1_n-e15a080").then(() => (() => (__webpack_require__(/*! @ionic-native/file/ngx */ 41766))))))),
	51347: () => (loadSingletonVersionCheckFallback("default", "@ngxs/store", [4,18,0,0], () => (__webpack_require__.e("node_modules_pnpm_ngxs_store_18_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_7_8_-0ea6db1").then(() => (() => (__webpack_require__(/*! @ngxs/store */ 31531))))))),
	51353: () => (loadSingletonVersionCheckFallback("default", "@awesome-cordova-plugins/geolocation/ngx", [4,6,8,0], () => (__webpack_require__.e("node_modules_pnpm_awesome-cordova-plugins_geolocation_6_8_0__awesome-cordova-plugins_core_6_8-1dcc270").then(() => (() => (__webpack_require__(/*! @awesome-cordova-plugins/geolocation/ngx */ 19599))))))),
	51649: () => (loadSingletonVersionCheckFallback("default", "@ionic-native/file-path/ngx", [4,5,36,0], () => (__webpack_require__.e("node_modules_pnpm_ionic-native_file-path_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs_7_-0c2b8c0").then(() => (() => (__webpack_require__(/*! @ionic-native/file-path/ngx */ 28532))))))),
	53344: () => (loadSingletonVersionCheckFallback("default", "ngx-currency", [4,18,0,0], () => (__webpack_require__.e("node_modules_pnpm_ngx-currency_18_0_0__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_-2a21670").then(() => (() => (__webpack_require__(/*! ngx-currency */ 15921))))))),
	60473: () => (loadSingletonVersionCheckFallback("default", "@awesome-cordova-plugins/app-version/ngx", [4,6,8,0], () => (__webpack_require__.e("node_modules_pnpm_awesome-cordova-plugins_app-version_6_8_0__awesome-cordova-plugins_core_6_8-d2d7f41").then(() => (() => (__webpack_require__(/*! @awesome-cordova-plugins/app-version/ngx */ 99575))))))),
	60502: () => (loadSingletonVersionCheckFallback("default", "leaflet", [4,1,9,4], () => (__webpack_require__.e("node_modules_pnpm_leaflet_1_9_4_node_modules_leaflet_dist_leaflet-src_js").then(() => (() => (__webpack_require__(/*! leaflet */ 95467))))))),
	60662: () => (loadSingletonVersionCheckFallback("default", "dayjs", [4,1,11,12], () => (__webpack_require__.e("node_modules_pnpm_dayjs_1_11_12_node_modules_dayjs_dayjs_min_js").then(() => (() => (__webpack_require__(/*! dayjs */ 24401))))))),
	61341: () => (loadSingletonVersionCheckFallback("default", "@capacitor/device", [4,8,0,1], () => (__webpack_require__.e("node_modules_pnpm_capacitor_device_8_0_1__capacitor_core_8_2_0_node_modules_capacitor_device_-43e8091").then(() => (() => (__webpack_require__(/*! @capacitor/device */ 68617))))))),
	66956: () => (loadSingletonVersionCheckFallback("default", "@capacitor/app", [4,8,0,1], () => (__webpack_require__.e("node_modules_pnpm_capacitor_app_8_0_1__capacitor_core_8_2_0_node_modules_capacitor_app_dist_e-7b1dae1").then(() => (() => (__webpack_require__(/*! @capacitor/app */ 83575))))))),
	72415: () => (loadSingletonVersionCheckFallback("default", "@capacitor-community/file-opener", [4,8,0,0], () => (__webpack_require__.e("node_modules_pnpm_capacitor-community_file-opener_8_0_0__capacitor_core_8_2_0_node_modules_ca-c434d91").then(() => (() => (__webpack_require__(/*! @capacitor-community/file-opener */ 11114))))))),
	76567: () => (loadSingletonVersionCheckFallback("default", "@capacitor/geolocation", [4,8,1,0], () => (__webpack_require__.e("node_modules_pnpm_capacitor_geolocation_8_1_0__capacitor_core_8_2_0_node_modules_capacitor_ge-3533e81").then(() => (() => (__webpack_require__(/*! @capacitor/geolocation */ 17279))))))),
	77300: () => (loadSingletonVersionCheckFallback("default", "@capacitor/privacy-screen", [4,2,0,1], () => (__webpack_require__.e("node_modules_pnpm_capacitor_privacy-screen_2_0_1__capacitor_core_8_2_0_node_modules_capacitor-23d40c1").then(() => (() => (__webpack_require__(/*! @capacitor/privacy-screen */ 94744))))))),
	81949: () => (loadSingletonVersionCheckFallback("default", "@capacitor-community/firebase-analytics", [4,7,0,1], () => (__webpack_require__.e("node_modules_pnpm_capacitor-community_firebase-analytics_7_0_1__capacitor_core_8_2_0_node_mod-810e751").then(() => (() => (__webpack_require__(/*! @capacitor-community/firebase-analytics */ 46104))))))),
	87867: () => (loadSingletonVersionCheckFallback("default", "@awesome-cordova-plugins/in-app-browser/ngx", [4,6,8,0], () => (__webpack_require__.e("node_modules_pnpm_awesome-cordova-plugins_in-app-browser_6_8_0__awesome-cordova-plugins_core_-3804e81").then(() => (() => (__webpack_require__(/*! @awesome-cordova-plugins/in-app-browser/ngx */ 48897))))))),
	91036: () => (loadSingletonVersionCheckFallback("default", "@ionic-native/file-picker/ngx", [4,5,36,0], () => (__webpack_require__.e("node_modules_pnpm_ionic-native_file-picker_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs_-17f8af1").then(() => (() => (__webpack_require__(/*! @ionic-native/file-picker/ngx */ 89718))))))),
	94335: () => (loadSingletonVersionCheckFallback("default", "ngx-lottie", [4,12,0,0], () => (__webpack_require__.e("node_modules_pnpm_ngx-lottie_12_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__lottie-we-2ca6021").then(() => (() => (__webpack_require__(/*! ngx-lottie */ 45742))))))),
	94921: () => (loadSingletonVersionCheckFallback("default", "xlsx", [4,0,18,5], () => (__webpack_require__.e("node_modules_pnpm_xlsx_0_18_5_node_modules_xlsx_xlsx_mjs").then(() => (() => (__webpack_require__(/*! xlsx */ 99091))))))),
	95306: () => (loadSingletonVersionCheckFallback("default", "capacitor-greatday-camera", [4,0,4,0], () => (__webpack_require__.e("node_modules_pnpm_capacitor-greatday-camera_0_4_0__capacitor_core_8_2_0_node_modules_capacito-7427920").then(() => (() => (__webpack_require__(/*! capacitor-greatday-camera */ 8808))))))),
	96749: () => (loadSingletonVersionCheckFallback("default", "@angular/router", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_router_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_-346ae21").then(() => (() => (__webpack_require__(/*! @angular/router */ 69132))))))),
	96902: () => (loadSingletonVersionCheckFallback("default", "ngx-clipboard", [1,16,0,0], () => (__webpack_require__.e("node_modules_pnpm_ngx-clipboard_16_0_0__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1-8966581").then(() => (() => (__webpack_require__(/*! ngx-clipboard */ 51603))))))),
	31749: () => (loadFallback("default", "@greatdayhr-custom/core", () => (__webpack_require__.e("libs_core_src_index_ts-_70f61").then(() => (() => (__webpack_require__(/*! @greatdayhr-custom/core */ 24929))))))),
	41075: () => (loadSingletonVersionCheckFallback("default", "@danielmoncada/angular-datetime-picker", [4,18,1,0], () => (__webpack_require__.e("node_modules_pnpm_danielmoncada_angular-datetime-picker_18_1_0__angular_cdk_18_1_2__angular_c-76ef7a1").then(() => (() => (__webpack_require__(/*! @danielmoncada/angular-datetime-picker */ 69553))))))),
	43646: () => (loadSingletonVersionCheckFallback("default", "ngxtension/derived-async", [4,4,3,2], () => (__webpack_require__.e("node_modules_pnpm_ngxtension_4_3_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zon-4a93721").then(() => (() => (__webpack_require__(/*! ngxtension/derived-async */ 27034))))))),
	90057: () => (loadSingletonVersionCheckFallback("default", "@ng-select/ng-select", [4,13,9,1], () => (__webpack_require__.e("node_modules_pnpm_ng-select_ng-select_13_9_1__angular_common_18_1_2__angular_core_18_1_2_rxjs-51d1181").then(() => (() => (__webpack_require__(/*! @ng-select/ng-select */ 34543))))))),
	51040: () => (loadSingletonVersionCheckFallback("default", "ngx-mask", [1,18,0,0], () => (__webpack_require__.e("node_modules_pnpm_ngx-mask_18_0_4__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone-9c57090").then(() => (() => (__webpack_require__(/*! ngx-mask */ 6443))))))),
	21060: () => (loadSingletonVersionCheckFallback("default", "@ionic-native/core", [4,5,36,0], () => (__webpack_require__.e("node_modules_pnpm_ionic-native_core_5_36_0_rxjs_7_8_1_node_modules_ionic-native_core_index_js").then(() => (() => (__webpack_require__(/*! @ionic-native/core */ 64700))))))),
	28872: () => (loadSingletonVersionCheckFallback("default", "@ionic/core/components", [4,8,2,6], () => (__webpack_require__.e("node_modules_pnpm_ionic_core_8_2_6_node_modules_ionic_core_components_index_js-_1b291").then(() => (() => (__webpack_require__(/*! @ionic/core/components */ 2271))))))),
	29295: () => (loadSingletonVersionCheckFallback("default", "@ionic/angular/common", [4,8,2,6], () => (__webpack_require__.e("node_modules_pnpm_ionic_angular_8_2_6__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0___angula-fe358f1").then(() => (() => (__webpack_require__(/*! @ionic/angular/common */ 64981))))))),
	36672: () => (loadSingletonVersionCheckFallback("default", "@ionic/core/loader", [4,8,2,6], () => (__webpack_require__.e("node_modules_pnpm_ionic_core_8_2_6_node_modules_ionic_core_loader_index_es2017_js").then(() => (() => (__webpack_require__(/*! @ionic/core/loader */ 56046))))))),
	59777: () => (loadSingletonVersionCheckFallback("default", "@ionic/core", [4,8,2,6], () => (__webpack_require__.e("node_modules_pnpm_ionic_core_8_2_6_node_modules_ionic_core_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! @ionic/core */ 63439))))))),
	27836: () => (loadSingletonVersionCheckFallback("default", "@angular/core/rxjs-interop", [4,18,1,2], () => (__webpack_require__.e("node_modules_pnpm_angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0_node_modules_angular_core_fes-f4e59c1").then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 52547))))))),
	8121: () => (loadSingletonVersionCheckFallback("default", "@ngxs/store/operators", [4,18,0,0], () => (__webpack_require__.e("node_modules_pnpm_ngxs_store_18_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_7_8_-083fe3").then(() => (() => (__webpack_require__(/*! @ngxs/store/operators */ 94235))))))),
	39365: () => (loadSingletonVersionCheckFallback("default", "@ngxs/store/internals", [4,18,0,0], () => (__webpack_require__.e("node_modules_pnpm_ngxs_store_18_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_7_8_-dcd86e0").then(() => (() => (__webpack_require__(/*! @ngxs/store/internals */ 1062))))))),
	74381: () => (loadSingletonVersionCheckFallback("default", "@ngxs/store/plugins", [4,18,0,0], () => (__webpack_require__.e("node_modules_pnpm_ngxs_store_18_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_7_8_-9f3b421").then(() => (() => (__webpack_require__(/*! @ngxs/store/plugins */ 55724))))))),
	88936: () => (loadSingletonVersionCheckFallback("default", "tslib", [4,2,5,0], () => (__webpack_require__.e("node_modules_pnpm_tslib_2_3_0_node_modules_tslib_tslib_es6_js").then(() => (() => (__webpack_require__(/*! tslib */ 67537))))))),
	99692: () => (loadSingletonVersionCheckFallback("default", "ngxtension/assert-injector", [4,4,3,2], () => (__webpack_require__.e("node_modules_pnpm_ngxtension_4_3_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zon-f3f8090").then(() => (() => (__webpack_require__(/*! ngxtension/assert-injector */ 3737))))))),
	71940: () => (loadSingletonVersionCheckFallback("default", "echarts", [4,5,5,1], () => (__webpack_require__.e("node_modules_pnpm_echarts_5_5_1_node_modules_echarts_index_js").then(() => (() => (__webpack_require__(/*! echarts */ 35612)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"node_modules_pnpm_angular_animations_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__n-bfe7a50": [
		45652,
		62182
	],
	"node_modules_pnpm_angular_animations_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__n-705bdd0": [
		45652,
		73558
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-51a67b0": [
		35581,
		38928,
		45652,
		57261,
		64729,
		69473,
		73558,
		84932,
		90065
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-fbbdc70": [
		45652,
		73558
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-42e5150": [
		45652
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-e044de0": [
		45652,
		84932
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-2f30270": [
		5853,
		38928,
		45652,
		57261,
		64729,
		67233,
		73558,
		78969,
		84932
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-35142b0": [
		38928,
		45652,
		57261,
		64729,
		84932
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-249bf50": [
		38928,
		45652,
		64729,
		84932
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-3c102c0": [
		13653,
		38928,
		45652,
		57261,
		64729,
		67233,
		69473,
		73558,
		78969,
		84932
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-513f7e0": [
		45652,
		73558
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-d452870": [
		45652,
		73558
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-0af4f60": [
		19869,
		38928,
		45652,
		57261,
		64729,
		73558,
		78969,
		84932
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-93c8c00": [
		19869,
		38928,
		45652,
		57261,
		64729,
		67233,
		73558,
		78969,
		84932
	],
	"node_modules_pnpm_angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_-1967500": [
		38928,
		45652,
		73558,
		84932
	],
	"node_modules_pnpm_angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_-e8892e0": [
		45652
	],
	"node_modules_pnpm_angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0_node_modules_angular_core_fes-f4e59c0": [
		38928,
		45652,
		84932
	],
	"node_modules_pnpm_angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0_node_modules_angular_core_fes-5f8e1c": [
		2846,
		84932,
		38928,
		77712
	],
	"node_modules_pnpm_angular_forms_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1-f1f5b00": [
		38928,
		45652,
		73558,
		84932
	],
	"node_modules_pnpm_angular_platform-browser_18_1_2__angular_animations_18_1_2__angular_core_18-67b8e30": [
		45652,
		18493,
		51618,
		73558
	],
	"node_modules_pnpm_angular_platform-browser_18_1_2__angular_animations_18_1_2__angular_core_18-5786651": [
		35072,
		45652,
		73558
	],
	"node_modules_pnpm_angular_router_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_-346ae20": [
		18493,
		38928,
		45652,
		73558,
		84932
	],
	"node_modules_pnpm_awesome-cordova-plugins_app-version_6_8_0__awesome-cordova-plugins_core_6_8-d2d7f40": [
		3129,
		44962,
		45652
	],
	"node_modules_pnpm_awesome-cordova-plugins_core_6_8_0_rxjs_7_8_1_node_modules_awesome-cordova--391b38": [
		84932
	],
	"node_modules_pnpm_awesome-cordova-plugins_diagnostic_6_8_0__awesome-cordova-plugins_core_6_8_-4b43011": [
		3129,
		44962,
		45652
	],
	"node_modules_pnpm_awesome-cordova-plugins_geolocation_6_8_0__awesome-cordova-plugins_core_6_8-1dcc271": [
		3129,
		44962,
		45652,
		84932
	],
	"node_modules_pnpm_awesome-cordova-plugins_http_6_8_0__awesome-cordova-plugins_core_6_8_0_rxjs-8debf20": [
		3129,
		44962,
		45652
	],
	"node_modules_pnpm_awesome-cordova-plugins_in-app-browser_6_8_0__awesome-cordova-plugins_core_-3804e80": [
		3129,
		44962,
		45652,
		84932
	],
	"node_modules_pnpm_capacitor-community_file-opener_8_0_0__capacitor_core_8_2_0_node_modules_ca-c434d90": [
		24003
	],
	"node_modules_pnpm_capacitor-community_firebase-analytics_7_0_1__capacitor_core_8_2_0_node_mod-810e750": [
		24003
	],
	"node_modules_pnpm_capacitor_app_8_0_1__capacitor_core_8_2_0_node_modules_capacitor_app_dist_e-7b1dae0": [
		24003
	],
	"node_modules_pnpm_capacitor_browser_8_0_2__capacitor_core_8_2_0_node_modules_capacitor_browse-b2ba0f0": [
		24003
	],
	"node_modules_pnpm_capacitor_camera_8_0_2__capacitor_core_8_2_0_node_modules_capacitor_camera_-1f1b4b0": [
		24003
	],
	"node_modules_pnpm_capacitor_clipboard_8_0_1__capacitor_core_8_2_0_node_modules_capacitor_clip-70a4310": [
		24003
	],
	"node_modules_pnpm_capacitor_device_8_0_1__capacitor_core_8_2_0_node_modules_capacitor_device_-43e8090": [
		24003
	],
	"node_modules_pnpm_capacitor_geolocation_8_1_0__capacitor_core_8_2_0_node_modules_capacitor_ge-3533e80": [
		24003
	],
	"node_modules_pnpm_capacitor_preferences_8_0_1__capacitor_core_8_2_0_node_modules_capacitor_pr-3bf03d1": [
		24003
	],
	"node_modules_pnpm_capacitor_privacy-screen_2_0_1__capacitor_core_8_2_0_node_modules_capacitor-23d40c0": [
		24003
	],
	"node_modules_pnpm_capacitor_screen-orientation_8_0_1__capacitor_core_8_2_0_node_modules_capac-979e2a0": [
		24003
	],
	"node_modules_pnpm_capgo_capacitor-file-picker_8_1_3__capacitor_core_8_2_0_node_modules_capgo_-9b64ae0": [
		24003
	],
	"node_modules_pnpm_danielmoncada_angular-datetime-picker_18_1_0__angular_cdk_18_1_2__angular_c-76ef7a0": [
		5853,
		13653,
		16786,
		38928,
		45652,
		57261,
		62182,
		64729,
		69473,
		73558,
		84932,
		95607
	],
	"libs_core_src_index_ts-_70f60": [
		1508,
		2779,
		2935,
		3169,
		3295,
		3539,
		5524,
		5738,
		5938,
		10734,
		13653,
		14183,
		14393,
		16786,
		18493,
		19869,
		20293,
		21893,
		24003,
		24210,
		28145,
		33562,
		35072,
		35581,
		38928,
		39579,
		39795,
		42069,
		43378,
		43509,
		44336,
		44718,
		44962,
		45652,
		47514,
		50655,
		51347,
		51353,
		51649,
		53344,
		60473,
		60502,
		60662,
		61341,
		62182,
		64729,
		66956,
		67233,
		72415,
		73558,
		76567,
		77300,
		78969,
		81949,
		84932,
		87867,
		91036,
		94335,
		94921,
		95306,
		95607,
		96749,
		96902
	],
	"libs_widget_src_index_ts-_518c1": [
		19869,
		45652,
		2935,
		73558,
		16786,
		60662,
		95607,
		62182,
		28145,
		78969,
		84932,
		38928,
		64729,
		18493,
		35072,
		43378,
		14183,
		13653,
		67233,
		94335,
		14393,
		53344,
		2779,
		31749,
		41075,
		43646,
		90057,
		57261,
		44962,
		51040,
		33562
	],
	"node_modules_pnpm_ionic-native_android-permissions_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_-dbaa2e1": [
		21060,
		44962,
		45652
	],
	"node_modules_pnpm_ionic-native_core_5_36_0_rxjs_7_8_1_node_modules_ionic-native_core_index_js": [
		84932
	],
	"node_modules_pnpm_ionic-native_file-chooser_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs-ff699b1": [
		21060,
		44962,
		45652
	],
	"node_modules_pnpm_ionic-native_file-path_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs_7_-0c2b8c1": [
		21060,
		44962,
		45652
	],
	"node_modules_pnpm_ionic-native_file-picker_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs_-17f8af0": [
		21060,
		44962,
		45652
	],
	"node_modules_pnpm_ionic-native_file_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs_7_8_1_n-e15a081": [
		21060,
		44962,
		45652
	],
	"node_modules_pnpm_ionic_angular_8_2_6__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0___angula-fe358f0": [
		16786,
		28872,
		38928,
		44962,
		45652,
		73558,
		84932,
		96749
	],
	"node_modules_pnpm_ionic_angular_8_2_6__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0___angula-42f6000": [
		16786,
		29295,
		36672,
		44962,
		45652,
		59777,
		73558,
		84932,
		96749
	],
	"node_modules_pnpm_meddv_ngx-pinch-zoom_18_0_1__angular_common_18_1_2__angular_core_18_1_2_rxj-0ddfaf1": [
		45652,
		73558
	],
	"node_modules_pnpm_ng-select_ng-select_13_9_1__angular_common_18_1_2__angular_core_18_1_2_rxjs-51d1180": [
		16786,
		38928,
		45652,
		73558,
		84932
	],
	"node_modules_pnpm_ngx-translate_core_15_0_0__angular_common_18_1_2__angular_core_18_1_2_rxjs_-a73e530": [
		38928,
		45652,
		84932
	],
	"node_modules_pnpm_ngxs_store_18_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_7_8_-dcd86e1": [
		27836,
		45652,
		84932
	],
	"node_modules_pnpm_ngxs_store_18_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_7_8_-9f3b420": [
		45652
	],
	"node_modules_pnpm_ngxs_store_18_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_7_8_-0ea6db0": [
		8121,
		38928,
		39365,
		45652,
		73558,
		74381,
		84932
	],
	"node_modules_pnpm_angular-svg-icon_18_0_3__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_-e902b70": [
		45652,
		84932,
		38928,
		73558,
		35072
	],
	"node_modules_pnpm_capacitor-google-play-services-checker_0_1_1__capacitor_core_8_2_0_node_mod-5a81870": [
		24003
	],
	"node_modules_pnpm_capacitor-greatday-camera_0_4_0__capacitor_core_8_2_0_node_modules_capacito-7427921": [
		24003
	],
	"node_modules_pnpm_capacitor-plugin-security-check_0_0_18__capacitor_core_8_2_0_node_modules_c-fb3cb10": [
		24003
	],
	"node_modules_pnpm_echarts_5_5_1_node_modules_echarts_index_js": [
		88936
	],
	"node_modules_pnpm_ngx-clipboard_16_0_0__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1-8966580": [
		45652,
		73558,
		84932
	],
	"node_modules_pnpm_ngx-currency_18_0_0__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_-2a21671": [
		16786,
		45652
	],
	"node_modules_pnpm_ngx-echarts_18_0_0_echarts_5_5_1_node_modules_ngx-echarts_fesm2022_ngx-echa-8fc8601": [
		45652,
		84932,
		38928
	],
	"node_modules_pnpm_ngx-image-compress_18_1_5__angular_common_18_1_2__angular_core_18_1_2_rxjs_-fc55b70": [
		45652,
		73558
	],
	"node_modules_pnpm_ngx-lottie_12_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__lottie-we-2ca6020": [
		27836,
		38928,
		45652,
		73558,
		84932
	],
	"node_modules_pnpm_ngx-mask_18_0_4__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone-9c57091": [
		16786,
		45652,
		73558
	],
	"node_modules_pnpm_ngxtension_4_3_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zon-f3f8091": [
		45652
	],
	"node_modules_pnpm_ngxtension_4_3_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zon-826c9a0": [
		45652
	],
	"node_modules_pnpm_ngxtension_4_3_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zon-4a93720": [
		45652,
		84932,
		99692
	],
	"node_modules_pnpm_rxjs_7_8_1_node_modules_rxjs_dist_esm_operators_index_js": [
		44962
	],
	"node_modules_pnpm_rxjs_7_8_1_node_modules_rxjs_dist_esm_index_js": [
		44962
	],
	"node_modules_pnpm_angular_animations_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__n-705bdd1": [
		73558
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-513f7e1": [
		73558
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-35142b1": [
		57261
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-0af4f61": [
		19869,
		57261
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-51a67b1": [
		35581,
		69473,
		90065
	],
	"node_modules_pnpm_angular_platform-browser_18_1_2__angular_animations_18_1_2__angular_core_18-5786650": [
		35072
	],
	"node_modules_pnpm_angular_animations_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__n-bfe7a51": [
		62182
	],
	"node_modules_pnpm_angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_-1967501": [
		38928,
		84932
	],
	"node_modules_pnpm_angular_forms_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1-f1f5b01": [
		38928,
		73558,
		84932
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-3c102c1": [
		57261,
		67233,
		69473,
		78969
	],
	"node_modules_pnpm_ionic_angular_8_2_6__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0___angula-42f6001": [
		29295,
		36672,
		44962,
		59777,
		73558,
		84932,
		96749
	],
	"node_modules_pnpm_ngx-lottie_12_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__lottie-we-2ca6021": [
		27836
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-2f30271": [
		5853,
		57261
	],
	"node_modules_pnpm_angular_cdk_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_z-93c8c01": [
		57261
	],
	"node_modules_pnpm_angular_router_18_1_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_-346ae21": [
		18493,
		38928,
		73558,
		84932
	],
	"node_modules_pnpm_awesome-cordova-plugins_http_6_8_0__awesome-cordova-plugins_core_6_8_0_rxjs-8debf21": [
		3129
	],
	"node_modules_pnpm_ionic-native_file_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs_7_8_1_n-e15a080": [
		21060
	],
	"node_modules_pnpm_ionic-native_file-path_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs_7_-0c2b8c0": [
		21060
	],
	"node_modules_pnpm_ionic-native_android-permissions_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_-dbaa2e0": [
		21060
	],
	"node_modules_pnpm_awesome-cordova-plugins_diagnostic_6_8_0__awesome-cordova-plugins_core_6_8_-4b43010": [
		3129
	],
	"node_modules_pnpm_awesome-cordova-plugins_in-app-browser_6_8_0__awesome-cordova-plugins_core_-3804e81": [
		3129
	],
	"node_modules_pnpm_awesome-cordova-plugins_geolocation_6_8_0__awesome-cordova-plugins_core_6_8-1dcc270": [
		3129
	],
	"node_modules_pnpm_ngxs_store_18_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_7_8_-0ea6db1": [
		8121,
		39365,
		74381
	],
	"node_modules_pnpm_awesome-cordova-plugins_app-version_6_8_0__awesome-cordova-plugins_core_6_8-d2d7f41": [
		3129
	],
	"node_modules_pnpm_ionic-native_file-chooser_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs-ff699b0": [
		21060
	],
	"node_modules_pnpm_ionic-native_file-picker_5_36_0__ionic-native_core_5_36_0_rxjs_7_8_1__rxjs_-17f8af1": [
		21060
	],
	"libs_core_src_index_ts-_70f61": [
		1508,
		2779,
		2935,
		3169,
		3295,
		3539,
		5524,
		5738,
		5938,
		10734,
		13653,
		14183,
		14393,
		18493,
		19869,
		20293,
		21893,
		24003,
		24210,
		33562,
		35072,
		35581,
		38928,
		39579,
		39795,
		42069,
		43378,
		43509,
		44336,
		44718,
		44962,
		47514,
		50655,
		51347,
		51353,
		51649,
		53344,
		60473,
		60502,
		60662,
		61341,
		62182,
		64729,
		66956,
		67233,
		72415,
		73558,
		76567,
		77300,
		78969,
		81949,
		84932,
		87867,
		91036,
		94335,
		94921,
		95306,
		95607,
		96749,
		96902
	],
	"node_modules_pnpm_ngxtension_4_3_2__angular_common_18_1_2__angular_core_18_1_2_rxjs_7_8_1_zon-4a93721": [
		99692
	],
	"node_modules_pnpm_danielmoncada_angular-datetime-picker_18_1_0__angular_cdk_18_1_2__angular_c-76ef7a1": [
		5853,
		69473
	],
	"node_modules_pnpm_ionic_angular_8_2_6__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0___angula-fe358f1": [
		28872,
		38928,
		44962
	],
	"node_modules_pnpm_angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0_node_modules_angular_core_fes-f4e59c1": [
		38928
	],
	"node_modules_pnpm_ngxs_store_18_0_0__angular_core_18_1_2_rxjs_7_8_1_zone_js_0_13_0__rxjs_7_8_-dcd86e0": [
		27836
	],
	"webpack_sharing_consume_default_echarts_echarts": [
		71940
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}